import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FeatureFlagsService } from '../services/feature-flags.service';

export const landingPageGuard: CanActivateFn = async (route, state) => {
  const featureFlagsService = inject(FeatureFlagsService);
  const router = inject(Router);

  try {
    // Verifica se a flag está ativada (sem necessidade de customerId na landing page)
    const isLandingPageEnabled = await featureFlagsService.hasFeature('frontend-enable-landing-page');
    
    // Se a flag estiver desativada e estiver tentando acessar a landing page
    if (!isLandingPageEnabled && state.url === '/') {
      // Redireciona para login
      return router.createUrlTree(['/login']);
    }
    
    return true;
  } catch (error) {
    console.error('Erro ao verificar feature flag:', error);
    // Em caso de erro, redireciona para login por segurança
    return router.createUrlTree(['/login']);
  }
};






